import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import TheLandingPage from "./pages/TheLandingPage.vue";

const ContactMePage = () => import("./pages/TheContactMePage.vue");
const PortfolioPage = () => import("./pages/PortfolioPage.vue");
const AboutPage = () => import("./pages/AboutPage.vue");

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: TheLandingPage,
  },
  {
    path: "/contact",
    name: "contact",
    // Lazy Loading Routes
    component: ContactMePage,
  },
  {
    path: "/portfolio",
    name: "portfolio",
    component: PortfolioPage,
  },

  {
    path: "/about-me",
    name: "about-me",
    component: AboutPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active-route",
});

export default router;
